var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.001,
    viewBox: "0 0 24 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 0A2.25 2.25 0 0 1 24 2.25v15a2.25 2.25 0 0 1-2.25 2.25H11.5l-5.8 4.35a.75.75 0 0 1-1.2-.6V19.5H2.25A2.25 2.25 0 0 1 0 17.25v-15A2.25 2.25 0 0 1 2.25 0zm0 1.5H2.25a.75.75 0 0 0-.75.75v15a.75.75 0 0 0 .75.75h3a.75.75 0 0 1 .75.75v3l4.8-3.6a.75.75 0 0 1 .45-.15h10.5a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75zM12 8.625a1.124 1.124 0 1 1-.123.007L12 8.625zm-4.5 0a1.124 1.124 0 1 1-.123.007l.123-.007zm9 0a1.124 1.124 0 1 1-.123.007l.123-.007z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.1e789277.svg";
export { ForwardRef as ReactComponent };